/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Otp_P_AfterInputs */

const es_ab_otp_p_after = /** @type {(inputs: Ab_Otp_P_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Introdúcelo abajo para terminar de publicar tu barco.`)
};

const gl_ab_otp_p_after = /** @type {(inputs: Ab_Otp_P_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Introdúceo abaixo para rematar de publicar o teu barco.`)
};

const en_ab_otp_p_after = /** @type {(inputs: Ab_Otp_P_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Enter it below to finish listing your boat.`)
};

/**
* | output |
* | --- |
* | ". Enter it below to finish listing your boat." |
*
* @param {Ab_Otp_P_AfterInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_otp_p_after = /** @type {((inputs?: Ab_Otp_P_AfterInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Otp_P_AfterInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_otp_p_after(inputs)
	if (locale === "en") return en_ab_otp_p_after(inputs)
	return es_ab_otp_p_after(inputs)
});